module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"subtitle":"Partner und Kooperationen von Foodtrucks United.","title":"Unsere Partner"},"en":{"subtitle":"Partners and cooperations of Foodtrucks United.","title":"Our partners"}}')
  delete Component.options._Ctor
}
